<template>
  <div>
    <div class="modal fade show" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Status w programie lojalnościowym </h4>
            <button class="close" type="button" @click="cancelUpdate()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="connectClient()" v-if="!parentClientIdSet">
              <p>Zmieniasz status klienta w programie lojalnościowym na <strong>Subkonto</strong></p>
              <div class="alert alert-warning" role="alert">
                Uwaga! Saldo wszystkich faktur klienta zostanie nieodwracalnie przeksięgowane na konto wskazanego
                klienta głównego.
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="parentClientId">Id klienta głównego</label>
                  <input class="form-control" id="parentClientId" autocomplete="off" v-model="parentClientId"
                         type="text"/>
                </div>
              </div>
              <button class="btn btn-primary mr-2" type="submit">Zmień</button>
              <button class="btn btn-secondary" @click="cancelUpdate()" type="button">Anuluj</button>
            </form>
            <div v-if="parentClientIdSet">
              <p>Zmieniasz status klienta w programie lojalnościowym na <strong>Konto główne</strong></p>
              <div>
                <button class="btn btn-primary mr-2" @click="disconnectClient()" type="button">Zmień</button>
                <button class="btn btn-secondary" @click="cancelUpdate()" type="button">Anuluj</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
  import clientService from '@Service/clients';
  import { toastError } from '../helpers';

  export default {
    props: ['client'],
    data() {
      return {
        parentClientId: '',
        parentClientIdSet: false,
      };
    },
    mounted() {
      this.parentClientIdSet = !!this.client.parentClientId;
    },
    methods: {
      cancelUpdate() {
        this.$emit('cancel-parent-client-update');
      },
      connectClient() {
        clientService.connectClient(this.client.clientId, this.parentClientId)
          .then(() => {
            this.$emit('client-updated');
            this.cancelUpdate();
          })
          .catch(toastError);
      },
      disconnectClient() {
        clientService.disconnectClient(this.client.clientId)
          .then(() => {
            this.$emit('client-updated');
            this.cancelUpdate();
          })
          .catch(toastError);
      },
    },
  };
</script>
